import { useMemo } from 'react';
import { range } from 'services/utils/range';
import { distanceBetweenDots, distanseBetweenLayers, dotDiametr } from '../initials';

const getLayers = ({
  density,
  height,
}) => {
  const arr = [];
  for (let i = 0; i < height; i++) {
    const rowCoefs = range(0, i + density - 1);
    const mapped = rowCoefs.map((item, index) => {
      return {
        coef: item,
      };
    });
    arr.push(mapped);
  }
  return arr;
};

const getDots = ({
  width,
  height,
  layersCount,
}) => {
  const layers = getLayers({
    density: 3,
    height: layersCount,
  });
  const dotsArr = [];
  layers.forEach(layer => {
    const layerDots = [];
    for (let i = 0; i <= layer.length; i++) {
      layerDots.push({ dotX: null, dotY: null, dotWidth: width, dotHeight: height });
    }
    dotsArr.push(layerDots);
  });
  return dotsArr;
};

const getDotsPositions = ({
  distanceX,
  distanceY,
  layersCount,
  widthCanvas,
}) => {
  const initialX = widthCanvas / 2 - distanceBetweenDots;
  const initialY = 0;

  const dotsArr = getDots({
    width: dotDiametr,
    height: dotDiametr,
    layersCount,
  });
  dotsArr.forEach((row, i) => {
    const newInitialX = initialX - distanceX / 2 * i;
    const newInitialY = initialY + [...dotsArr].splice(0, i).reduce((agg) => agg + distanceY, 0);
    row.forEach((dot, index) => {
      dot.dotY = newInitialY;
      dot.dotX = newInitialX + distanceX * index;
    });
  });
  return dotsArr;
};

const getMinXPosition = (dotsArr) => {
  let minPosition = dotsArr[0][0].dotX;
  dotsArr.forEach((row, i) => {
    row.forEach((item, index) => {
      if (item.dotX < minPosition) {
        minPosition = item.dotX;
      }
    });
  });
  return minPosition;
}

const getNormalizeDotsArr = (dotsArr) => {
  const minX = getMinXPosition(dotsArr);
  const newDotsArr = dotsArr.map(row => {
    return row.map(item => {
      return { ...item, dotX: item.dotX - minX };
    });
  });
  return newDotsArr;
};

export const useDots = ({
  height,
  widthCanvas,
}) => useMemo(() => {
  const dotsPos = getDotsPositions({
    distanceX: distanceBetweenDots,
    distanceY: distanseBetweenLayers,
    layersCount: height,
    widthCanvas,
  });
  return getNormalizeDotsArr(dotsPos);
}, [height, widthCanvas]);
